import { render, staticRenderFns } from "./ResourceRecord.vue?vue&type=template&id=481e8c9e"
import script from "./ResourceRecord.vue?vue&type=script&lang=js"
export * from "./ResourceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports